import React from "react";
import { Form, Modal, Row } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  AddFunding,
  DeleteFunding,
  GetFundingDetails,
  UpdateFunding,
} from "../../../../api/User/ACG/FundingApi";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import CustomButton from "../../../../components/common/CustomButton";
import DeleteModal from "../../../../components/common/Modal/DeleteModal";
import toastFile from "../../../../Service/ToastFile";
import CustomInputField from "../../../../components/common/CustomInputField";

const schema = Yup.object().shape({
  funding_Arrangement: Yup.string().matches(/^[a-zA-Z0-9\s-]*$/, 'No special characters are allowed.').required("Please enter funding arrangement"),
});

const FundingArrangement = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isGetData, setIsGetData] = useState(false);
  const [witchAction, setWitchAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const buttonRef = useRef(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const column = [
    { title: "Funding Arrangement", field: "funding_Arrangement" },
  ];

  useEffect(() => {
    if (showModal === false) {
      setSelectedRowData(null);
    }
    if (isGetData) {
      getIndustryRiskData();
    }
    setIsGetData(false);
  }, [showModal]);

  useEffect(() => {
    getIndustryRiskData();
  }, []);

  const getIndustryRiskData = () => {
    setIsLoading(true);
    GetFundingDetails()
      .then((res) => {
        if(res.status === 200 || res.status === 204){
        setData(res.data);
        }
      })
      .catch((err) => console.log({ err }))
      .finally((res) => setIsLoading(false));
  };

  const handleActions = (values) => {
    buttonRef.current.disabled = true;

    if (witchAction === "add") {
      let payload = { id: 0, funding_Arrangement: values.funding_Arrangement };
      const newItem = {
        id: 0,
        funding_Arrangement: values.funding_Arrangement,
      };
      setData([...data, newItem]);
      AddFunding(payload).then((res) => {
        if(res.status === 200 || res.status === 204){
        setIsGetData(true);
        toastFile("new");
        setShowModal(false);
        }
      });
    } else if (witchAction === "update") {
      let payload = {
        id: selectedRowData.id,
        funding_Arrangement: values.funding_Arrangement,
      };
      const updatedData = data.map((item, index) => {
        if (index === selectedRowData?.tableData.id) {
          return { ...item, funding_Arrangement: values.funding_Arrangement };
        }
        return item;
      });
      setData(updatedData);
      UpdateFunding(payload).then((res) => {
        if(res.status === 200 || res.status === 204){
        setIsGetData(true);
        toastFile("update");
        setShowModal(false);
        }
      });
    }
  };

  return (
    <div>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            {witchAction === "add"
              ? "Add "
              : witchAction === "update"
              ? "Update "
              : "Delete "}
            Funding Arrangement
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {witchAction === "delete" ? (
            <DeleteModal
              onClickYes={() => {
                DeleteFunding(selectedRowData?.id).then((res) => {
                  if(res.status === 200 || res.status === 204){
                  //setIsDataChanged("delete");
                  toastFile("delete");
                  setIsGetData(true);
                  setShowModal(false);
                  }
                });
              }}
              onClickNo={() => setShowModal(false)}
            />
          ) : (
            <Formik
              validationSchema={schema}
              onSubmit={handleActions}
              initialValues={{
                funding_Arrangement: selectedRowData
                  ? selectedRowData.funding_Arrangement
                  : "",
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <Row className="mb-2 gap-3">
                    <CustomInputField
                      label="Funding Arrangement"
                      name="funding_Arrangement"
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      isRequired
                    />
                  </Row>
                  <div className="d-flex align-items-center justify-content-end gap-3 my-4">
                    <button
                      ref={buttonRef}
                      style={Fontstyling.savebutton}
                      type="submit"
                    >
                      save
                    </button>
                    <button
                      style={Fontstyling.cancelbutton}
                      type="reset"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          )}
        </Modal.Body>
      </Modal>
      <div className="text-end py-3 border-bottom">
        <CustomButton
          onClick={() => {
            setWitchAction("add");
            setShowModal(true);
          }}
        >
          Add Funding Arrangement
        </CustomButton>
      </div>
      <CustomMaterialTable
        column={column}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={setWitchAction}
        setSelectedRowData={setSelectedRowData}
        setShowModal={setShowModal}
        isLoading={isLoading}
      />
    </div>
  );
};

export default FundingArrangement;
